// extracted by mini-css-extract-plugin
export default {"outlet":"AdminPage_outlet__y1qve","outletWrap":"AdminPage_outletWrap__UtCgg","active":"AdminPage_active__G9dnk"};